import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';

// Components
import PrivateRoute from './components/auth/PrivateRoute';

// Pages - will be implemented later
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import GalleryPage from './pages/GalleryPage';
import ARPage from './pages/ARPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import AdminPage from './pages/AdminPage';

const Routes: React.FC = () => {
  return (
    <RouterRoutes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/ar" element={<ARPage />} />
      <Route path="/contact" element={<ContactPage />} />

      <Route path="/login" element={<LoginPage />} />
      
      {/* Protected routes */}
      <Route element={<PrivateRoute />}>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
      </Route>
      
      {/* Fallback route - redirects to home */}
      <Route path="*" element={<HomePage />} />
    </RouterRoutes>
  );
};

export default Routes;